import { Presentation } from '@phosphor-icons/react';

export default Presentation;
